<template>
  <a-layout class="layout" :class="[device]">
    <a-layout
      :class="[layoutMode, `content-width-${contentWidth}`]"
      :style="{ paddingLeft: fixSiderbar && isDesktop() ? `${sidebarOpened ? 200 : 80}px` : '0' }">
      <!-- layout header -->
      <global-header
        :mode="layoutMode"
        :menus="[]"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="()=>{}"
        :isAdmin="false"
      />

      <!-- layout content -->
      <a-layout-content :style="{ height: '100%', paddingTop: fixedHeader ? '59px' : '0' }">
        <router-view />
      </a-layout-content>
    </a-layout>
    <div class="fixed-message-notice">
      <MessageNotice />
    </div>
  </a-layout>
</template>

<script>
  import GlobalHeader from '@/components/page/project/GlobalHeader'
  // update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------
  // import SettingDrawer from '@/components/setting/SettingDrawer'
  // 注释这个因为在个人设置模块已经加载了SettingDrawer页面
  // update-end ---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------

  import { mapState } from 'vuex'
  import { mixin, mixinDevice } from '@/utils/mixin.js'
  import MessageNotice from '@/components/mes/MessageNotice.vue'

  export default {
    name: 'HomeLayout',
    components: {
      GlobalHeader,
      // update-start---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------
      // // SettingDrawer
      // 注释这个因为在个人设置模块已经加载了SettingDrawer页面
      // update-end ---- author:os_chengtgen -- date:20190830 --  for:issues/463 -编译主题颜色已生效，但还一直转圈，显示主题 正在编译 ------
      MessageNotice,
    },
    mixins: [mixin, mixinDevice],
    data() {
      return {
        collapsed: false,
        activeMenu:{},
      }
    },
    computed: {
      ...mapState({
        // 主路由
        mainRouters: state => state.permission.addRouters,
      })
    },
    watch: {

    },
    created() {

    },
    methods: {


    }
  }

</script>

<style lang="less">
.fixed-message-notice {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1000;
}
</style>
